import { render, staticRenderFns } from "./TheAccount.vue?vue&type=template&id=3023e1e8&"
import script from "./TheAccount.vue?vue&type=script&lang=js&"
export * from "./TheAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports